import React from "react";
import { TrendChart } from "@/components/TrendChart";
import { ArrowUpRight } from "lucide-react";

export function MetricCard({ title, label, trend, formatter, onClick, testId }) {
  return (
    <button
      onClick={onClick}
      data-testid={testId}
      className="group text-left bg-white border border-slate-200 rounded-sm shadow-sm p-5 flex flex-col hover:-translate-y-1 hover:shadow-lg transition-all duration-200"
    >
      <div className="flex items-center justify-between mb-3">
        <span className="bg-[#E2333F] text-white text-[11px] font-bold uppercase tracking-wider px-3 py-1 rounded-sm">
          {title}
        </span>
        <ArrowUpRight className="w-4 h-4 text-slate-300 group-hover:text-[#E2333F] transition-colors" />
      </div>
      <div className="font-display font-bold text-slate-900 text-base mb-1">{label}</div>
      <div className="mt-auto">
        <TrendChart data={trend} height={170} formatter={formatter} testId={`${testId}-chart`} />
      </div>
    </button>
  );
}
